
import React, {useEffect, useState} from "react";
import {getLinkFromUrl, getProductDetailLink, isAdmin, user} from "../../utils/Utils";
import {toDateTimeString, toHumanizedDuration} from "../../utils/TimeUtil"
import {ScraperService} from "../../service/ScraperService";
import {RequestProbeService} from "../../service/RequestProbeService";
import {Button} from "primereact/button";
import {Dialog} from "primereact/dialog";
import {InputTextarea} from "primereact/inputtextarea";
import {Dropdown} from "primereact/dropdown";

import {ErrorService} from "../../service/ErrorService";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {Panel} from "primereact/panel";
import {Tag} from "primereact/tag";
import {AppContext} from "../../HomePage";
import {TabPanel, TabView} from "primereact/tabview";
import CopyToClipboard from "../../utils/CopyToClipboard";
import {job_states} from "../../utils/Constants";
import {Loading} from "../../utils/InlineComponents";

const ScrapeStatus = (props) => {

    const {t, toast, setError} = React.useContext(AppContext);
    const [showDetail, setShowDetail] = useState(false);
    const [showReport, setShowReport] = useState(false);
    const [reportType, setReportType] = useState('incorrect_price');
    const [reportMessage, setReportMessage] = useState('');
    const [allJobsInfo, setAllJobsInfo] = useState([]);
    const [loading, setLoading] = useState(false);
    const [copyingFailureResponseHash, setCopyingFailureResponseHash] = useState(null);

    const [tabIndex, setTabIndex] = useState(0);
    const scraping_request = props.scraping_request;
    const parent_request = props.parent_request;

    const [selectedScrapingRequest, setSelectedScrapingRequest] = useState(null);
    const [showSelectedScrapingRequestDetail, setShowSelectedScrapingRequestDetail] = useState(false);
    // Estimated completion of a still-running request, fetched when the detail
    // dialog opens. null = no estimate to show (no history, or already done).
    const [eta, setEta] = useState(null);
    // Admin-only: the request's Zyte job keys read fresh when the dialog opens (the
    // row's snapshot may predate the dispatch), plus the latest earlier Zyte job of
    // the same user/campaign/type/spider while this one has none yet.
    const [zyteJobs, setZyteJobs] = useState(null);

    const scraperService = new ScraperService();
    const requestProbeService = new RequestProbeService();
    const errorService = new ErrorService();
    const [probeLoading, setProbeLoading] = useState(false);

    // Create a product_url request probe for this competitor's URL, so the
    // scraping can be diagnosed/fixed from the Request Probe screen.
    const createProductUrlProbe = () => {
        const url = props.competitor_url;
        if (!url)
            return;
        setProbeLoading(true);
        requestProbeService.createProbe(url, 'product_url', null, {
            campaign_id: props.campaign_id,
            product_id: props.product_id,
        }).then(() => {
            setProbeLoading(false);
            toast.current.show({severity: 'success', summary: t('request_probe.create_new'), detail: t('message_detail.successful')});
        }).catch(error => {
            setProbeLoading(false);
            setError(error);
            setError(null);
        });
    };

    const getAllJobsInfo = () => {
        if (props.campaign_id && isAdmin()) {
            setAllJobsInfo([])
            setLoading(true);
            scraperService.getTodayScrapingRequests(props.campaign_id).then(jobsInfo => {
                getAllJobsCurrentStatus(jobsInfo)
            }).catch(error =>{
                setError(error);
                setError(null);
                setLoading(false);
            });
        }
    };

    const getAllJobsCurrentStatus = (jobsInfo) => {
        for (let i = 0; i < jobsInfo.length; i++) {
            let jobInfo = jobsInfo[i]
            let id = jobInfo.spider_args.scraping_request_id
            let job_key = jobInfo.job_key
            scraperService.getScrapingRequestStatus(id, job_key).then(data => {
                jobInfo.spider_args.divided_job_no = data.spider_args?.divided_job_no
                jobInfo.spider_args.divided_job_units = data.spider_args?.divided_job_units
                jobInfo.close_reason = data.close_reason
                jobInfo.items_scraped = data.items_scraped
                jobInfo.state = data.state
                jobInfo.spider_name = data.spider_name
                jobInfo.started_time = data.started_time
                jobInfo.updated_time = data.updated_time
                jobInfo.errors_count = data.errors_count
                if (i === (jobsInfo.length - 1)) {
                    setLoading(false);
                    jobsInfo.sort( compareJobs );
                    setAllJobsInfo(jobsInfo)
                }
            }).catch(error =>{
                setError(error);
                setError(null);
                setLoading(false);
            });
        }
    };

    const compareJobs = ( a, b ) => {
        if ( a.created_at > b.created_at ){
            return -1;
        }
        if ( a.created_at < b.created_at ){
            return 1;
        }

        if ( parseInt(a.spider_args?.divided_job_no) < parseInt(b.spider_args?.divided_job_no) ){
            return -1;
        }
        if (parseInt(a.spider_args?.divided_job_no) > parseInt(b.spider_args?.divided_job_no) ){
            return 1;
        }
        return 0;
    }

    // The state a customer is shown for a request. A failed campaign-wide price
    // check / product import is an internal problem the customer can do nothing
    // about (we retry it ourselves), so non-admins see it as completed instead
    // of a scary red "Failed". Every place that reacts to the state -- icon,
    // tooltip, status row, "is it still running" -- must go through this, or the
    // card would claim success while the run button stays disabled.
    const effectiveState = (request) => {
        const state = request && request.state ? request.state : "";
        if (state === job_states.failed && !isAdmin() && request &&
            (request.type === "prices_campaign_update" || request.type === "products_create"))
            return job_states.done;
        return state;
    };

    const getScrapingStatus = (scraping_request, t) =>{

        let status = effectiveState(scraping_request);



        let colorClass="";
        let style = {};
        let icon;
        let tooltip = "";

        if (props.type === "price") {
            icon = "pi pi-tag";
            colorClass = "p-button-success";
            tooltip = t('actions.request_price_check');
        }
        else if (props.type === "product") {
            icon = "pi pi-tags";
            colorClass = "p-button-success";
            tooltip = t('actions.request_product_update');
        }
        else if (props.type === "suggest") {
            icon = "pi pi-google";
            colorClass = "p-button-info";
            tooltip = t('actions.request_find_matches');
        }
        else if (props.type === "reviews") {
            icon = "pi pi-comments";
            colorClass = "p-button-help";
            tooltip = t('scraping_request.partial_product_update');
        }
        else if (props.type === "failed_reviews") {
            icon = "pi pi-comments";
            colorClass = "p-button-danger";
            tooltip = t('scraping_request.partial_product_update');
        }
        else {
            icon = "pi pi-check-circle";
            colorClass = "p-button-help";
            tooltip = "";
        }
        if (props.text)
            tooltip = props.text;

        if (status === "") {
            tooltip += "\n\n" + t('scraping_request.statuses.done')
        }
        else if (status === job_states.done) {
            // Both timestamps, so the customer can see when the check ran without
            // opening the detail dialog.
            tooltip += "\n\n" + t('scraping_request.statuses.done');
            if (scraping_request.started_at)
                tooltip += "\n" + t('scraping_request.started_at') + " : " + toDateTimeString(scraping_request.started_at);
            tooltip += "\n" + t('scraping_request.completed_at') + " : " + toDateTimeString(scraping_request.completed_at);
        }
        else if (status === job_states.failed) {
            style={borderColor:"red",color:"red"}
            tooltip += "\n\n" + (t('scraping_request.statuses.failed') + " : " + toDateTimeString(scraping_request.completed_at));
        }
        else if (status === job_states.todo) {
            style={borderColor:"maroon",color:"maroon"}
            tooltip += "\n\n" + (t('scraping_request.statuses.todo') + " : " + toDateTimeString(scraping_request.created_at));
        }
        else if (status === job_states.in_progress) {
            style={borderColor:"lightsalmon",color:"lightsalmon"}
            tooltip += "\n\n" + (t('scraping_request.statuses.in_progress') + " : " + toDateTimeString(scraping_request.started_at));
            icon += " pi-spin"
        }
        else if (status === job_states.in_preparation) {
            style={borderColor:"deepskyblue",color:"deepskyblue"}
            tooltip += "\n\n" + t('scraping_request.statuses.in_preparation');
            icon += " pi-spin"
        }

        return <Button onClick={() => setShowDetail(true)} icon={icon} className={"p-button-outlined p-button-rounded p-mr-1 " + colorClass} style={style} tooltipOptions={{position: 'bottom'}} tooltip={tooltip} />;
    };


    let result = parent_request && (parent_request.state === job_states.todo || parent_request.state === job_states.in_progress) ? getScrapingStatus(parent_request, t) : getScrapingStatus(scraping_request, t);

    let is_running = false;
    if (props.type !== "product")
    {
        is_running = false;
        if (isAdmin())// && selectedProduct.scraping_request.state === job_states.failed)
            is_running = false;
        else if (parent_request && effectiveState(parent_request) !== job_states.done)
            is_running = true;
        else if (scraping_request && effectiveState(scraping_request) !== job_states.done)
            is_running = true;
    }
    else {
        if (isAdmin())// && selectedProduct.scraping_request.state === job_states.failed)
            is_running = false;
        else if (parent_request && (parent_request.state === job_states.todo || parent_request.state === job_states.in_progress))
            is_running = true;
        else if (scraping_request && (scraping_request.state === job_states.todo || scraping_request.state === job_states.in_progress))
            is_running = true;
    }

    // A request the customer is still waiting on. Uses the displayed state, so a
    // failed run that non-admins see as "done" never asks for an estimate.
    const displayed_state = effectiveState(scraping_request);
    const is_pending = displayed_state === job_states.todo || displayed_state === job_states.in_progress
        || displayed_state === job_states.in_preparation;
    const scraping_request_id = scraping_request ? scraping_request.id : null;

    // Only fetched while the dialog is open -- these components are rendered
    // once per row/card, and an eager fetch would be a request per row.
    useEffect(() => {
        setEta(null);
        if (!showDetail || !is_pending || !scraping_request_id)
            return;
        let cancelled = false;
        scraperService.getScrapingRequestEta(scraping_request_id).then(data => {
            if (!cancelled)
                setEta(data && data.estimated_completion_at ? data : null);
        }).catch(() => {
            // An estimate is a nicety; a failure here must not surface an error
            // dialog on top of the job detail.
            if (!cancelled)
                setEta(null);
        });
        return () => { cancelled = true; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showDetail, is_pending, scraping_request_id]);

    useEffect(() => {
        setZyteJobs(null);
        if (!showDetail || !isAdmin() || !scraping_request_id)
            return;
        let cancelled = false;
        scraperService.getScrapingRequestZyteJobs(scraping_request_id).then(data => {
            if (!cancelled)
                setZyteJobs(data || null);
        }).catch(() => {
            // Falls back to the snapshot's job keys; never an error dialog.
            if (!cancelled)
                setZyteJobs(null);
        });
        return () => { cancelled = true; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showDetail, scraping_request_id]);

    const report = () => {

        errorService.addError(scraping_request ? scraping_request.id : null, props.campaign_id, props.product_id, props.competitor_url, reportMessage, reportType).then(() => {
            setShowReport(false);
            setReportMessage('');
            toast.current.show({severity: 'success', summary: t('actions.report_failure'), detail: t('message_detail.successful')});
        }).catch(error =>{
            setError(error);
            setError(null);
        });
    };
    const tooltip = props.type === "price" ?
        t('actions.request_price_check') : (props.type === "suggest" ?
            t('actions.request_find_matches') : (props.type === "product" ?
                t('actions.request_product_update') : (props.type === "partial_product_update" ?
                    t('scraping_request.partial_product_update') : "")));

    const saveNewRequest = () => {

        // Custom trigger (e.g. a dedicated endpoint like shipping_prices) instead
        // of the generic saveScrapingRequest.
        if (props.onRun){
            Promise.resolve(props.onRun()).then(() => {
                if (props.newRequestCompleted) props.newRequestCompleted();
                toast.current.show({severity: 'success', summary: props.runLabel || tooltip, detail: t('message_detail.successful')});
            }).catch(error =>{
                setError(error);
                setError(null);
            });
        }
        else if (props.newRequest){
            scraperService.saveScrapingRequest(props.newRequest).then(scraping_requests_created=>{
                props.newRequestCompleted(scraping_requests_created);
                toast.current.show({severity: 'success', summary: tooltip, detail: t('message_detail.successful')});
            }).catch(error =>{
                setError(error);
                setError(null);
            });
        }
        else
        {
            props.newRequestCompleted();
        }
    };

    const reportTypes = [
        {label: t('scraping_request.report_types.incorrect_price'), value: 'incorrect_price'},
        {label: t('scraping_request.report_types.incorrect_availability'), value: 'incorrect_availability'},
        {label: t('scraping_request.report_types.incorrect_product_matching'), value: 'incorrect_product_matching'},
        {label: t('scraping_request.report_types.incorrect_data'), value: 'incorrect_data'},
        {label: t('scraping_request.report_types.other'), value: 'other'}
    ];

    const stateSeverity = (s) => s === job_states.done ? 'success'
        : s === job_states.failed ? 'danger'
        : s === job_states.in_progress || s === job_states.in_preparation ? 'warning'
        : s === job_states.todo ? 'info' : null;
    const statusTemplate = () => {
        const s = effectiveState(scraping_request);
        return <React.Fragment>
            <div className="p-col-3"><h6><b>{t('scraping_request.status', 'Durum')}</b></h6></div>
            <div className="p-col-9"><Tag value={s ? t('scraping_request.statuses.' + s, s) : '-'} severity={stateSeverity(s)}/></div>
        </React.Fragment>;
    };
    const typeTemplate = () => {
        return <React.Fragment>
            <div className="p-col-3"><h6><b>{t('scraping_request.type', 'Tip')}</b></h6></div>
            <div className="p-col-9">{scraping_request.type ? t('scraping_request.from_' + scraping_request.type, scraping_request.type) : '-'}</div>
        </React.Fragment>;
    };
    const spiderNameTemplate = () => {
        return <React.Fragment>
            <div className="p-col-3"><h6><b>{t('scraping_request.spider_name', 'Spider')}</b></h6></div>
            <div className="p-col-9">{scraping_request.spider_name || '-'}</div>
        </React.Fragment>;
    };
    const createdAtTemplate = () => {
        return <React.Fragment>
            <div className="p-col-3"><h6><b>{t('billing.created_at', 'Oluşturulma')}</b></h6></div>
            <div className="p-col-9">{toDateTimeString(scraping_request.created_at)}</div>
        </React.Fragment>;
    };
    const startedAtTemplate = () =>{
        return <React.Fragment>
            <div className="p-col-3"><h6><b>{t('scraping_request.started_at')}</b></h6></div>
            <div className="p-col-9">{toDateTimeString(scraping_request.started_at)}</div>
        </React.Fragment>;
    };
    const completedAtTemplate = () => {
        return <React.Fragment>
            <div className="p-col-3"><h6><b>{t('scraping_request.completed_at')}</b></h6></div>
            <div className="p-col-9">{toDateTimeString(scraping_request.completed_at)}</div>
        </React.Fragment>;
    };
    const etaTemplate = () => {
        const remaining = new Date(eta.estimated_completion_at).getTime() - new Date().getTime();
        return <React.Fragment>
            <div className="p-col-3"><h6><b>{t('scraping_request.estimated_completion', 'Tahmini Bitiş')}</b></h6></div>
            <div className="p-col-9">
                {remaining > 0
                    ? t('scraping_request.finishes_in', 'Yaklaşık {duration} içinde bitecek')
                        .replace('{duration}', toHumanizedDuration(remaining))
                    : t('scraping_request.finishing_soon', 'Birazdan bitecek')}
                <span style={{color: '#6b7280', marginLeft: '.5em'}}>({toDateTimeString(eta.estimated_completion_at)})</span>
            </div>
        </React.Fragment>;
    };
    const requestIdTemplate = () => {
        return <React.Fragment>
            <div className="p-col-3"><h6><b>{t('scraping_request.id')}</b></h6></div>
            <div className="p-col-9">{scraping_request.id}<CopyToClipboard textToCopy={scraping_request.id} /></div>
        </React.Fragment>;
    };
    // Zyte (Scrapy Cloud) job links. A request may spawn several divided jobs;
    // each job_key is "project/spider/job" -> https://app.zyte.com/p/<job_key>.
    const zyteJobKeys = () => {
        const fresh = zyteJobs && zyteJobs.job_keys;
        return fresh && fresh.length > 0 ? fresh : (scraping_request.job_keys || []);
    };
    const zyteLink = (k) => <a target="_blank" rel="noopener noreferrer" href={'https://app.zyte.com/p/' + k}>{k}</a>;
    const zyteLinksTemplate = () => {
        const keys = zyteJobKeys();
        return <React.Fragment>
            <div className="p-col-3"><h6><b>{t('scraping_request.zyte_job', 'Zyte Job')}</b></h6></div>
            <div className="p-col-9">
                {keys.map((k, i) => (
                    <div key={i} style={{wordBreak: 'break-all'}}>{zyteLink(k)}</div>
                ))}
            </div>
        </React.Fragment>;
    };
    // Shown while this request has no Zyte job yet: the newest job of the same
    // user, campaign, type and spider.
    const latestZyteJobTemplate = () => {
        const latest = zyteJobs.latest;
        return <React.Fragment>
            <div className="p-col-3"><h6><b>{t('scraping_request.latest_zyte_job', 'Latest Zyte Job')}</b></h6></div>
            <div className="p-col-9" style={{wordBreak: 'break-all'}}>
                {zyteLink(latest.job_key)}
                {latest.created_at && <span> ({toDateTimeString(latest.created_at)}{latest.state ? ', ' + t('scraping_request.statuses.' + latest.state, latest.state) : ''})</span>}
            </div>
        </React.Fragment>;
    };
    const productTemplate = (scraping_request) => {
        return scraping_request.product_id ? <React.Fragment>
            <div className="p-col-12">{getProductDetailLink(scraping_request.product_id, t('scraping_request.product_id'))}</div>
        </React.Fragment> : null;
    };
    const dividedJobTemplate = (rowData) => {
        let job_id = rowData.spider_args.divided_job_no ? (parseInt(rowData.spider_args.divided_job_no) + 1) + "/" + rowData.spider_args.divided_job_units : "1/1";
        return <a target="_blank" rel="noopener noreferrer" href={rowData.url}>{job_id}</a>;
    };
    const scrapingRequestIdTemplate = (rowData) => {
        return rowData.spider_args.scraping_request_id;
    };

    const actionTemplate = (rowData) => {
        return <React.Fragment>
            <Button icon="pi pi-info" className="p-button-outlined p-button-info" tooltip={t('actions.detail')} style={{marginRight: '.5em'}} onClick={() => {showStatusDetailPage(rowData);}}/>
        </React.Fragment> ;
    };

    const showStatusDetailPage = (rowData) => {
        scraperService.getScrapingRequest(rowData.spider_args.scraping_request_id).then(data=>{
            setShowSelectedScrapingRequestDetail(true);
            setSelectedScrapingRequest(data);
        }).catch(error => {
            setError(error);
            setError(null);
            setShowSelectedScrapingRequestDetail(false);
        });

    }

    const showFailures = () => {
        if (selectedScrapingRequest && selectedScrapingRequest.failure_details && selectedScrapingRequest.failure_details.length > 0) {
            return <Panel header={t('scraping_request.job_detail')} toggleable={true}>
                <Button label={t('actions.back')} icon="pi pi-arrow-left" className="p-button-outlined p-button-success" onClick={(e) => {setShowSelectedScrapingRequestDetail(false)}}/>
                {isAdmin() && <div className="p-grid p-col-12">{productTemplate(selectedScrapingRequest)}</div>}
                {isAdmin() && <div className="p-grid p-col-12">{urlTemplate(selectedScrapingRequest)}</div>}
                {isAdmin() && <div className="p-grid p-col-12">{competitorUrlTemplate(selectedScrapingRequest)}</div>}
                {isAdmin() && <div className="p-grid p-col-12">{urlsTemplate(selectedScrapingRequest)}</div>}
                {isAdmin() && <div className="p-grid p-col-12">{failureTemplate(selectedScrapingRequest)}</div>}
                {isAdmin() && <div className="p-grid p-col-12">{ignoredTemplate(selectedScrapingRequest)}</div>}
            </Panel>
        }

        return <Button label={t('actions.back')} icon="pi pi-arrow-left" className="p-button-outlined p-button-success" onClick={(e) => {setShowSelectedScrapingRequestDetail(false)}}/>
    }

    const jobInfoTemplate = (jobs) => {
        return jobs.length > 0 ? <React.Fragment>
            <DataTable value={jobs} header={t('scraping_request.job_state')} responsive={true} paginator={true} rows={10}>
                <Column field="spider_args.divided_job_no" body={dividedJobTemplate} header={t('scraping_request.divided_job_no')}/>
                <Column field="spider_args.scraping_request_id" body={scrapingRequestIdTemplate} header={t('scraping_request.id')}/>
                <Column field="spider" header={t('scraping_request.spider_name')}/>
                <Column field="type" header={t('scraping_request.type')}/>
                <Column field="close_reason" header={t('scraping_request.close_reason')}/>
                <Column field="state" header={t('scraping_request.state')}/>
                <Column field="started_time" header={t('scraping_request.started_at')}/>
                <Column field="updated_time" header={t('scraping_request.updated_time')}/>
                <Column field="items_scraped" header={t('scraping_request.items_scraped')}/>
                <Column field="errors_count" header={t('scraping_request.errors_count')}/>
                <Column body={actionTemplate} style={{textAlign: 'center'}}  style={{width:"5em"}}/>
            </DataTable>
        </React.Fragment> : null;
    };
    const urlTemplate = (scraping_request) => {
        return scraping_request.url ?
            <React.Fragment>
                <div className="p-col-3">{t('scraping_request.url')}</div>
                <div className="p-col-9">
                    {getLinkFromUrl(scraping_request.url)}
                </div>
            </React.Fragment> : null;
    };
    const competitorUrlTemplate = (scraping_request) => {
        return scraping_request.competitor_url ?
            <React.Fragment>
                <div className="p-col-3">{t('scraping_request.competitor_url')}</div>
                <div className="p-col-9">
                    {getLinkFromUrl(scraping_request.competitor_url)}
                </div>
            </React.Fragment> : null;
    };

    const urlRowTemplate = (rowData) => {
        return getLinkFromUrl(rowData.url);
    };
    const urlsTemplate = (scraping_request) => {
        return scraping_request.urls && scraping_request.urls.length > 0 ?
            <React.Fragment>
                <DataTable value={scraping_request.urls} responsive={true} header={t('scraping_request.urls')}>
                    <Column field="url" body={urlRowTemplate} header={t('scraping_request.url')}/>
                </DataTable>
            </React.Fragment> : null;
    };
    const failedUrlTemplate = (rowData) => {
        return getLinkFromUrl(rowData.url);
    };
    const failedProductTemplate = (rowData) => {
        return getProductDetailLink(rowData.product_id, t('scraping_request.product_id'));
    };
    const failedRedirectUrlTemplate = (rowData) => {
        return getLinkFromUrl(rowData.redirect_url);
    };
    const failedCompetitorUrlTemplate = (rowData) => {
        return getLinkFromUrl(rowData.competitor_url);
    };

    const exceptionValueTemplate = (value) => {
        if (value === null || value === undefined || value === "")
            return null;
        if (typeof value === "object")
            return <pre style={{margin: 0, whiteSpace: "pre-wrap"}}>{JSON.stringify(value, null, 2)}</pre>;
        return value.toString();
    };

    const hasExceptionDetailValue = (value) => {
        if (value === null || value === undefined || value === "")
            return false;
        if (typeof value === "object")
            return Object.values(value).some(hasExceptionDetailValue);
        return true;
    };

    const exceptionTemplate = (rowData) => {
        const exceptionDetail = rowData.exception_detail;
        const hasExceptionDetail = hasExceptionDetailValue(exceptionDetail);

        if (hasExceptionDetail && typeof exceptionDetail === "object") {
            return <div style={{maxWidth: "32em", whiteSpace: "normal", wordBreak: "break-word"}}>
                {Object.entries(exceptionDetail).map(([key, value]) =>
                    <div key={key} style={{marginBottom: ".5em"}}>
                        <b>{key}: </b>{exceptionValueTemplate(value)}
                    </div>
                )}
            </div>;
        }

        return <div style={{maxWidth: "32em", whiteSpace: "normal", wordBreak: "break-word"}}>
            {hasExceptionDetail ? exceptionValueTemplate(exceptionDetail) : exceptionValueTemplate(rowData.exception)}
        </div>;
    };

    const copyFailureResponse = (scraping_request, rowData) => {
        if (!scraping_request || !rowData.exception_hash)
            return;

        setCopyingFailureResponseHash(rowData.exception_hash);
        scraperService.getFailureResponse(rowData.exception_hash).then(data => {
            navigator.clipboard.writeText(data && data.response_text ? data.response_text : "").then(() => {
                toast.current.show({severity: 'success', summary: t('actions.copied'), detail: t('message_detail.successful')});
                setCopyingFailureResponseHash(null);
            }).catch(error => {
                setError(error);
                setError(null);
                setCopyingFailureResponseHash(null);
            });
        }).catch(error => {
            setError(error);
            setError(null);
            setCopyingFailureResponseHash(null);
        });
    };

    const failureResponseTemplate = (scraping_request, rowData) => {
        if (!rowData.exception_hash)
            return null;

        const isCopying = copyingFailureResponseHash === rowData.exception_hash;

        return <Button icon={isCopying ? "pi pi-spin pi-spinner" : "pi pi-copy"}
                       className="p-button-outlined p-button-info imageButton preventSelect"
                       tooltip={t('actions.copy')}
                       tooltipOptions={{position: 'bottom'}}
                       disabled={isCopying}
                       onClick={(e) => {
                           e.stopPropagation();
                           copyFailureResponse(scraping_request, rowData);
                       }}/>;
    };

    const failureTemplate = (scraping_request) => {
        return scraping_request.failure_details && scraping_request.failure_details.length > 0 ? <React.Fragment>
            <DataTable value={scraping_request.failure_details} header={t('scraping_request.failure_details')}
                       responsive={true} paginator={true} rows={10}>
                <Column field="url" body={failedUrlTemplate} header={t('scraping_request.url')} sortable/>
                <Column field="redirect_url" body={failedRedirectUrlTemplate} header={t('scraping_request.redirect_url')} sortable/>
                <Column field="product_id" body={failedProductTemplate} header={t('scraping_request.product_id')} sortable />
                <Column field="competitor_url" body={failedCompetitorUrlTemplate} header={t('scraping_request.competitor_url')} sortable/>
                <Column field="exception_detail" body={exceptionTemplate} header={t('scraping_request.exception')} sortable/>
                <Column body={(rowData) => failureResponseTemplate(scraping_request, rowData)} header="Response Body" style={{textAlign: 'center', width: '7em'}}/>
            </DataTable>
        </React.Fragment> : null;
    };
    const ignoredTemplate = (scraping_request) => {
        return scraping_request.ignored_errors && scraping_request.ignored_errors.length > 0 ? <React.Fragment>

            <DataTable value={scraping_request.ignored_errors} header={t('scraping_request.ignored_errors')}
                       responsive={true} paginator={true} rows={10}>
                <Column field="url" body={failedUrlTemplate} header={t('scraping_request.url')} sortable/>
                <Column field="redirect_url" body={failedRedirectUrlTemplate} header={t('scraping_request.redirect_url')} sortable/>
                <Column field="product_id" body={failedProductTemplate} header={t('scraping_request.product_id')} sortable/>
                <Column field="competitor_url" body={failedCompetitorUrlTemplate} header={t('scraping_request.competitor_url')} sortable/>
                <Column field="exception_detail" body={exceptionTemplate} header={t('scraping_request.exception')} sortable/>
                <Column body={(rowData) => failureResponseTemplate(scraping_request, rowData)} header="Response Body" style={{textAlign: 'center', width: '7em'}}/>
            </DataTable>

        </React.Fragment> : null;
    };

    // Body of the "Job Detail" view. Extracted so it can be rendered either as
    // the first tab (admins, who also get the "All Jobs Detail" tab) or on its
    // own without any tab bar -- customers have nothing to switch to, and
    // React.Children.map would hand TabView a null child if the second panel
    // were merely conditional.
    const jobDetailBody = <React.Fragment>
        {scraping_request && <div className="p-grid p-col-12">{statusTemplate()}</div>}
        {isAdmin() && scraping_request && scraping_request.type && <div className="p-grid p-col-12">{typeTemplate()}</div>}
        {isAdmin() && scraping_request && scraping_request.spider_name && <div className="p-grid p-col-12">{spiderNameTemplate()}</div>}
        {isAdmin() && scraping_request && scraping_request.created_at && <div className="p-grid p-col-12">{createdAtTemplate()}</div>}
        {/* Skip the timestamp rows that have no value yet -- a queued job would
            otherwise show blank "Started"/"Ended" lines next to its estimate. */}
        {scraping_request && scraping_request.started_at && <div className="p-grid p-col-12">{startedAtTemplate()}</div>}
        {scraping_request && scraping_request.completed_at && <div className="p-grid p-col-12">{completedAtTemplate()}</div>}
        {eta && <div className="p-grid p-col-12">{etaTemplate()}</div>}
        {isAdmin() && scraping_request && <div className="p-grid p-col-12">{requestIdTemplate()}</div>}
        {isAdmin() && scraping_request && zyteJobKeys().length > 0 &&
            <div className="p-grid p-col-12">{zyteLinksTemplate()}</div>}
        {isAdmin() && scraping_request && zyteJobKeys().length === 0 && zyteJobs && zyteJobs.latest &&
            <div className="p-grid p-col-12">{latestZyteJobTemplate()}</div>}
        <div className="p-col-12" style={{textAlign:"right"}}>
            {isAdmin() && props.competitor_url &&
                <Button icon="pi pi-bolt" className="p-button-outlined p-button-help" style={{marginRight: ".5em"}}
                        loading={probeLoading} disabled={probeLoading}
                        label={t('request_probe.create_new')} onClick={() => createProductUrlProbe()}/>}
            {/* readOnly: status-only usage (e.g. the campaign card for
                non-admins) where the dialog must not offer a manual run. */}
            <span>{!props.readOnly && (props.type || props.onRun) && <Button disabled={is_running ? "disabled" : ""} icon="pi pi-refresh"
                className={"p-button-outlined p-button-success " + (props.compact ? "p-button-rounded p-button-sm" : "p-button")}
                label={props.compact ? null : (props.runLabel || tooltip)}
                tooltip={props.compact ? (props.runLabel || tooltip) : undefined} tooltipOptions={{position: 'bottom'}}
                onClick={() => saveNewRequest()}/>}</span>
        </div>
        <br/>

        {isAdmin() && scraping_request && scraping_request.failure_details && scraping_request.failure_details.length > 0 &&
            <Panel header={t('scraping_request.job_detail')} toggleable={true}>
                <div className="p-grid p-col-12">{productTemplate(scraping_request)}</div>
                <div className="p-grid p-col-12">{urlTemplate(scraping_request)}</div>
                <div className="p-grid p-col-12">{competitorUrlTemplate(scraping_request)}</div>
                <div className="p-grid p-col-12">{urlsTemplate(scraping_request)}</div>
                <div className="p-grid p-col-12">{failureTemplate(scraping_request)}</div>
                <div className="p-grid p-col-12">{ignoredTemplate(scraping_request)}</div>
            </Panel>
        }
    </React.Fragment>;

    return <React.Fragment>
        {result}
        {props.competitor_url &&
            <Button icon="pi pi-question-circle" className="p-button-outlined p-button-rounded p-button-warning p-mr-1"
                    tooltipOptions={{position: 'bottom'}} tooltip={t('actions.report_failure')}
                    onClick={() => setShowReport(true)}/>}

        <Dialog header={t('actions.report_failure')} visible={showReport} style={{textAlign:"left", width: '40vw', minWidth: '20vw'}}
                modal={true} onHide={() => setShowReport(false)} maskClassName="preventSelect">
            <div className="p-grid" style={{marginTop: ".5em"}}>
                <div className="p-col-3">
                    <b>{t('scraping_request.report_type')}</b>
                </div>
                <div className="p-col-9">
                    <Dropdown id="report_type" name="report_type" value={reportType} options={reportTypes} onChange={(e) => setReportType(e.value)} />
                </div>
                <div className="p-col-3">
                    <b>{t('scraping_request.report_message')}</b>
                </div>
                <div className="p-col-9">
                    <InputTextarea id="report_message" name="report_message" rows={5} cols={50} value={reportMessage} autoResize={true} onChange={(e) =>  setReportMessage(e.target.value) } />
                </div>
                <div className="p-col-3"></div>
                <div className="p-col-9">
                    <Button label={t('actions.report_failure')} icon="pi pi-envelope" className="p-button-outlined p-button-success" onClick={() => report()} style={{marginRight:"0.5em"}} />
                </div>
            </div>
        </Dialog>

        <Dialog header={t('scraping_request.job_detail')} visible={showDetail} style={{textAlign:"left", width: isAdmin() ? '80vw': '50vw', minWidth: '20vw'}} modal={true} onHide={() => setShowDetail(false)} maskClassName="preventSelect">
            <br/>
            {/* "All Jobs Detail" lists raw Zyte jobs and is admin-only, so
                customers get the job detail on its own with no tab bar. */}
            {isAdmin()
                ? <TabView activeIndex={tabIndex} onTabChange={(e) => setTabIndex(e.index)} style={{paddingTop:"0", paddingLeft:"0", paddingRight:"0"}}>
                    <TabPanel header={t('scraping_request.job_detail')} leftIcon="pi pi-info-circle" >
                        {jobDetailBody}
                    </TabPanel>
                    <TabPanel header={t('scraping_request.all_jobs_detail')} leftIcon="pi pi-info-circle" >
                        <div className="p-grid p-col-12">
                            <Button label={t('scraping_request.show_all_today_jobs_status')} icon="pi pi-info-circle" className="p-button-outlined p-button-warning" onClick={() => getAllJobsInfo()} style={{marginRight:"0.5em"}} />
                        </div>

                        {loading ?
                            <div className="p-col-12" style={{textAlign: 'center'}}>
                                <Loading/>
                            </div> :
                            <div className="p-grid p-col-12">
                                {showSelectedScrapingRequestDetail ? showFailures() : jobInfoTemplate(allJobsInfo)}
                            </div>
                        }

                    </TabPanel>
                </TabView>
                : <div>{jobDetailBody}</div>}
        </Dialog>

    </React.Fragment>;
};
export default ScrapeStatus;
